import * as React from 'react';
import {
  type GDSHeadingLevel,
  GDSSpace,
  HeadingText,
  type GDSHeadingSize,
} from '@leagueplatform/genesis-core';
import {
  Traits,
  WidgetType,
  GenesisFontSizeTokens,
} from '@leagueplatform/masonry-api';
import { MasonryEngineNode } from '@leagueplatform/masonry-engine';
import { useGetTraitsForMedia } from '@leagueplatform/masonry-widgets';
import { getSectionHeaderId } from 'utils/get-section-header-id.util';
import { APP_MANAGED_ANCHORS } from 'common/app-managed-routes';

type HeadingSizeMap = {
  [key in GenesisFontSizeTokens]: GDSHeadingSize;
};

export const headingSizeMap: HeadingSizeMap = {
  'xx-large': 'xxl',
  'x-large': 'xl',
  large: 'lg',
  medium: 'md',
  small: 'sm',
  'x-small': 'xs',
};

export const mapHeadingSizeToGenesisTokens = (
  headingSize?: GenesisFontSizeTokens | null,
) => {
  if (!headingSize || !(headingSize in headingSizeMap)) {
    return undefined;
  }

  return headingSizeMap[headingSize as GenesisFontSizeTokens];
};

export interface SectionHeaderProps {
  heading: string;
  headingLevel?: GDSHeadingLevel;
  traits?: Traits;
  paddingTop?: GDSSpace;
}

export type SectionHeaderWSNode = MasonryEngineNode<
  WidgetType.SECTION_HEADER,
  SectionHeaderProps
>;

export const SectionHeader = ({
  heading,
  headingLevel = '2',
  paddingTop = '$one',
  traits,
}: SectionHeaderProps) => {
  const traitItems = useGetTraitsForMedia(traits);
  const headingSize =
    mapHeadingSizeToGenesisTokens(traitItems?.headingSize) ?? 'xl';
  const headingId = getSectionHeaderId(heading);

  const isCareDiscoveryLandingPage = heading === 'Access Care Now';

  return (
    <>
      {isCareDiscoveryLandingPage && (
        <span id={APP_MANAGED_ANCHORS.CARE.FIND_AND_PLAN_CARE} />
      )}
      <HeadingText
        size={headingSize}
        level={headingLevel}
        css={{
          paddingTop,
        }}
        id={headingId}
      >
        {heading}
      </HeadingText>
    </>
  );
};
